import React from 'react'
import Header from '../shared/Header/Header'
import { BackButton, baseUrl } from './Examples'

const ExampleHeader = (): JSX.Element => {
    return (
        <div style={{ top: 100, position: 'relative' }}>
            <div>
                <h2>Component Header, exemplo 1:</h2>
                <BackButton href={baseUrl} />

                <Header title="Example 1" total={10} status={[]} />

                <h2>Component Header, exemplo 2:</h2>
                <Header title="Example 2" total={10} titleStatus="Active" status={[]} />

                <h2>Component Header, exemplo 3:</h2>
                <Header
                    title="Example 3"
                    total={10}
                    titleStatus="Active"
                    status={[
                        {
                            id: '123',
                            icon: 'far fa-map-marked-alt',
                            color: 'blue',
                            title: 'Maps',
                            subtitle: 'Location',
                            subtitle2: 'Coordinates',
                            background: 'yellow'
                        }
                    ]}
                />

                <h2>Component Header, exemplo 4:</h2>
                <Header
                    title="Example 4"
                    total={10}
                    titleStatus="Active"
                    status={[
                        {
                            id: '123',
                            icon: 'far fa-map-marked-alt',
                            color: 'blue',
                            title: 'Maps',
                            subtitle: 'Location',
                            subtitle2: 'Coordinates',
                            background: 'yellow'
                        },
                        {
                            id: '456',
                            icon: 'fas fa-route',
                            color: 'green',
                            title: 'Routes',
                            subtitle: 'Trajectory',
                            subtitle2: 'Paths',
                            background: 'yellow'
                        }
                    ]}
                />
            </div>
        </div>
    )
}

export default ExampleHeader
